var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"start-claim"},[_c(_vm.currentPage,{tag:"component"}),(_vm.paymentLoader)?_c('PaymentLoader'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }